import { CIMSSingleColumn } from 'components/CIMSTable/CIMSColumn/types'
import { IdentifiedFieldIssue } from '../../../../IFITrackerContext/types'
import { IFIStatus, alphabeticalCompare, alphabeticalSort } from 'shared'
import { HelpMessage } from 'utils/constants'
import { SortOptions } from 'components/CIMSTable/CIMSColumn/types/sort'
import Status from './components/Status'

export function useStatus(
  options: Required<Pick<SortOptions<IdentifiedFieldIssue>, 'priority'>>
): CIMSSingleColumn<IdentifiedFieldIssue> {
  return {
    title: 'Status',
    render: (record) => <Status {...record} />,
    width: 135,
    help: HelpMessage.IdentifiedFieldIssues.IFITracker.Status,
    sort: {
      ...options,
      with: 'callback',
      default: 'ascend',
      onCompare: (a, b) => {
        const A = IFIStatus.fromIdOrFail(a.statusId)
        const B = IFIStatus.fromIdOrFail(b.statusId)
        return alphabeticalCompare(A, B, 'priority')
      },
    },
    filter: {
      type: 'default',
      with: 'items',
      key: 'statusId',
      items: IFIStatus.sort(alphabeticalSort('priority')).map(
        ({ id, name, description }) => ({
          value: id,
          text: name,
          tooltip: description,
        })
      ),
    },
  }
}
